function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBradyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 832.36,
    height: 157.893,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M171.988 638.066c22.739 176.168 172.992 312.356 355.325 312.356 182.378 0 332.593-136.188 355.32-312.356H1209.6c115.01 0 119.69 116.149 119.69 116.149l2.47 306.355s-2.47 123.54-139.44 123.54H0V638.066h171.988M1192.3 551.594H883.563c-20.032-179.024-171.797-318.313-356.25-318.313-184.415 0-336.215 139.289-356.235 318.313H0V5.578H1209.58c115.03 0 119.7 116.113 119.7 116.113l2.48 306.372s-2.48 123.531-139.46 123.531",
    style: {
      fill: "#19336e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 157.893)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.313 862.738c-149.629 0-270.922-121.25-270.922-270.902 0-149.613 121.293-270.957 270.922-270.957 149.64 0 270.968 121.344 270.968 270.957 0 149.652-121.328 270.902-270.968 270.902M2276.67 182.422h-307.38V536.68h317.99c192.85 0 192.31-178.203 192.31-178.203s-1.09-176.055-202.92-176.055zm-306.91 823.718h273.54c166.84 0 166.84-151.898 166.84-151.898s-1.17-163.484-175.76-163.484h-265.77l1.15 315.382zm462.84-357.999s156.41 40.843 156.41 237.019c0 127.11-111.95 298.08-309.07 298.08h-484.42V3.73h530.58s330.39-12.109 330.39 334.93c0 232.137-223.89 309.481-223.89 309.481M4864.03 178.809h-244.72l.47 827.301s66.47-.34 246.78-.34c180.38 0 387.45-163.997 387.45-416.457 0-254.321-225.12-410.504-389.98-410.504zM2851.24 580.324l-1.08 426.206h217.15c90.98 0 206.53-60.354 206.53-208.053 0-215.231-193.73-218.153-264.14-218.153h-158.46zm1982.71 602.896c-94.12-.6-391.48 0-391.48 0l-.82-1006.579-47.12.058-390.86 1006.441H3807.9L3389.11 124.121l-232.4 328.594s294.11 36.293 294.11 355.805c0 223.24-155.26 377.1-397.89 375.59-170.7-1.06-387.65 0-387.65 0l1.36-1180.38h181.54v557.868L3252.93 3.73h288.65l363.08 920.981 292.25-747.941h-502.86L3622.68 3.73s1175.58-.66 1260.56 0c273.46 2.06 542.17 225.594 549.86 590.622 6.13 289.41-221.11 591.108-599.15 588.868",
    style: {
      fill: "#19336e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 157.893)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5233.45 1184.08 405.84-795.779.34-384.57h184.4v384.093l418.7 796.356h-205.24l-299.68-586.563-295.99 586.463h-208.37M5985.75 42.621h19v43.73h21.24l29.76-43.472 20.71.82-30.18 43.461c23.29 4.75 28.4 18.09 28.4 32.07 0 20.29-19.27 30.02-37.93 30.02h-51V42.621Zm17.3 93.07h23.15c19.34 0 31.19-2.55 31.19-17.351 0-15.328-10.15-17.699-26.64-18.39h-27.7v35.741",
    style: {
      fill: "#19336e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 157.893)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6028.3 13.07c-44.94 0-81.23 36.36-81.23 81.23 0 44.962 36.29 81.36 81.23 81.36 44.87 0 81.31-36.398 81.31-81.36 0-44.87-36.44-81.23-81.31-81.23zm0 175.68c-52.15 0-94.37-42.281-94.37-94.45 0-52.081 42.22-94.3 94.37-94.3 52.1 0 94.45 42.219 94.45 94.3 0 52.169-42.35 94.45-94.45 94.45",
    style: {
      fill: "#19336e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 157.893)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBradyLogo);
export default __webpack_public_path__ + "static/media/brady-logo.259f29f6cd075dfc9f72246a1db01ab6.svg";
export { ForwardRef as ReactComponent };